import { Dispatch, SetStateAction, useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { history } from '../../../history';
import { Form } from '../../../models/form/form';
import { createFormFromTemplate as createFormService } from '../../../services/form/FormService';

interface Values {
  isLoading: boolean;
  createFormFromTemplate: (name: string, languages: string[], templateId: string, avatarFile: File) => void;
  setOrganizationId: Dispatch<SetStateAction<string>>;
}

const useCreateFormFromTemplate = (organizationId: string): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [id, setOrganizationId] = useState<string>(organizationId);

  const createFormFromTemplate = async (name: string, languages: string[], templateId: string, avatarFile: File) => {
    try {
      setIsLoading(true);
      const newForm = new Form(id, 'New form');
      newForm.name = name;
      newForm.localizations = languages;

      const result = await createFormService(organizationId, newForm, templateId, avatarFile);
      setIsLoading(false);
      history.push('/registrations/admin/edit-form/' + result.data.id, { formCreated: true });
    } catch (error) {
      handleError(error);
      setIsLoading(false);
    }
  };

  return { createFormFromTemplate, isLoading, setOrganizationId };
};

export default useCreateFormFromTemplate;
